/**
 * SIMPS Drink Lab — constants.js
 * Global constants. No product data, no scoring weights (see scoringConfig.js).
 */
window.DrinkLab = window.DrinkLab || {};

window.DrinkLab.DRINK_LAB_DATA_VERSION = '1.0.0';

window.DrinkLab.MINIMUM_RECOMMENDATION_SCORE = 45;

window.DrinkLab.TIE_BREAK_MARGIN = 2;

window.DrinkLab.LOADING_MESSAGES = [
  'Analyzing flavour profile...',
  'Calculating deliciousness...',
  'Consulting the goose...',
  'Ignoring several safety protocols...',
  'Adding more syrup...',
  "This probably won't explode..."
];

window.DrinkLab.LOADING_DURATION_MS = 1800;

window.DrinkLab.ADVENTURE_COPY = {
  classic: { label: 'KEEP IT CLASSIC', sub: 'I know what I like.' },
  experiment: { label: "LET'S EXPERIMENT", sub: 'Show me something different.' },
  goose: { label: 'UNSUPERVISED GOOSE', sub: 'Dash, you have complete creative control.' }
};

window.DrinkLab.LAB_PACK_OFFER = {
  enabled: true,
  quantity: 3,
  headline: '3 for $33',
  description: 'Build your home Drink Lab.'
};

window.DrinkLab.DEBUG_QUERY_PARAM = 'drinkLabDebug';
